import * as React from "react"

export const WebinarsIcon = ({
  width = 40,
  height = 40,
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...rest}
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="8" fill="#F9F2FF" />

    <path
      d="M30 18V24V18ZM10 18L20 13L30 18L20 23L10 18Z"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 20V25C17 28 23 28 26 25V20"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
